// Options should be an array with elements in the the format: { name, value }

const flattenOptionsError = (errors) => {
  const errorsArray = [];
  const error = errors[0];
  if (typeof error === 'string') errorsArray.push(error);
  else if (typeof error === 'object' && error.errors) {
    errorsArray.push(Object.values(error.errors)[0]?.error.value[0]);
  }
  return errorsArray;
};

export default flattenOptionsError;
